import React, { useState } from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const NotificationPanel = ({ notifications, onMarkRead, onMarkAllRead }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const unreadCount = notifications?.filter((n) => !n?.read)?.length;

  const getTypeIcon = (type) => {
    switch (type) {
      case "asignacion": return { name: "Package", color: "var(--color-primary)" };
      case "expiracion": return { name: "Clock", color: "var(--color-warning)" };
      case "sistema": return { name: "Bell", color: "var(--color-secondary)" };
      case "activacion": return { name: "CheckCircle", color: "var(--color-success)" };
      default: return { name: "Info", color: "var(--color-muted-foreground)" };
    }
  };

  return (
    <div
      className="rounded-xl border bg-white"
      style={{ borderColor: "var(--color-border)", boxShadow: "var(--shadow-sm)" }}
    >
      <div
        className="flex items-center justify-between p-4 cursor-pointer lg:cursor-default"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-2">
          <Icon name="Bell" size={18} color="var(--color-primary)" />
          <h2 className="font-semibold text-sm md:text-base" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
            Notificaciones
          </h2>
          {unreadCount > 0 && (
            <span className="text-xs font-bold px-2 py-0.5 rounded-full" style={{ backgroundColor: "var(--color-accent)", color: "white" }}>
              {unreadCount}
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          {unreadCount > 0 && (
            <button
              className="text-xs hidden lg:block"
              style={{ color: "var(--color-primary)" }}
              onClick={(e) => { e?.stopPropagation(); onMarkAllRead(); }}
            >
              Marcar todas
            </button>
          )}
          <Icon name={isExpanded ? "ChevronUp" : "ChevronDown"} size={16} color="var(--color-muted-foreground)" className="lg:hidden" />
        </div>
      </div>
      <div className={`${isExpanded ? "block" : "hidden"} lg:block`}>
        <div className="divide-y max-h-80 overflow-y-auto scrollbar-thin" style={{ borderColor: "var(--color-border)" }}>
          {notifications?.length === 0 ? (
            <div className="p-4 text-center text-sm" style={{ color: "var(--color-muted-foreground)" }}>
              Sin notificaciones
            </div>
          ) : (
            notifications?.map((notif) => {
              const icon = getTypeIcon(notif?.type);
              return (
                <div
                  key={notif?.id}
                  className={`flex gap-3 p-3 cursor-pointer hover:bg-gray-50 transition-colors ${!notif?.read ? "bg-blue-50/40" : ""}`}
                  onClick={() => onMarkRead(notif?.id)}
                >
                  <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${icon?.color}15` }}>
                    <Icon name={icon?.name} size={14} color={icon?.color} />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-xs font-medium line-clamp-2" style={{ color: "var(--color-foreground)" }}>{notif?.message}</p>
                    <p className="text-xs mt-0.5" style={{ color: "var(--color-muted-foreground)" }}>{notif?.time}</p>
                  </div>
                  {!notif?.read && (
                    <div className="w-2 h-2 rounded-full flex-shrink-0 mt-1" style={{ backgroundColor: "var(--color-primary)" }} />
                  )}
                </div>
              );
            })
          )}
        </div>
        {unreadCount > 0 && (
          <div className="p-3 border-t lg:hidden" style={{ borderColor: "var(--color-border)" }}>
            <Button variant="ghost" size="sm" fullWidth onClick={onMarkAllRead}>
              Marcar todas como leídas
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationPanel;